import React, { FC } from 'react';
import cn from 'classnames';
import { useTheme } from '../../../../../../theme';
import { CdnIcon } from '@shared/ui';
import { IconButton } from '../../../../../../BaseComponents/Button';
import { AppFile, openFileInNewTab, useFileUpload } from '@shared/lib/file-upload';
import { UploadedFile } from '@shared/ui/file-upload/UploadedFile';
import { useTranslation } from 'react-i18next';
import { MAX_FILE_SIZE_MB, STRING_SUPPORTED_FILE_MIME, STRING_SUPPORTED_FILE_TYPES } from '@shared/model/file-upload';

interface Props {
	files?: AppFile[];
	title: string;
	description?: string;
	onChange?: (files: File[]) => void;
	onDelete?: (fileId: string) => void;
}
const AttachFile: FC<Props> = ({ files, title, description, onChange, onDelete }) => {
	const { t } = useTranslation();

	const { AttachFile: css } = useTheme('Shared').FileUpload;

	const { inputRef, onChangeHandler, onClickHandler } = useFileUpload({
		files,
		onChange
	});

	const separator = !!description ? ':' : '';
	const selected = !!files?.length;

	return (
		<div className={cn(css.root, { [css.selected]: selected })}>
			<input
				ref={inputRef}
				type="file"
				accept={STRING_SUPPORTED_FILE_MIME}
				name={'file'}
				onChange={onChangeHandler}
				hidden
				multiple
			/>

			<div className={css.leftBlock}>
				{selected && <CdnIcon className={css.includedIcon} icon="Info/Item Icluded" />}

				<div className={css.fileBlock}>
					<div className={css.infoBlock}>
						{!!title && (
							<span className={css.title}>
								{title}
								{separator}
							</span>
						)}

						{!!description && <span className={css.description}>{description}</span>}
					</div>

					{selected && (
						<div className={css.files}>
							{files.map(file => (
								<UploadedFile
									key={file.id}
									name={file.file.name}
									error={t(file.error, {
										types: STRING_SUPPORTED_FILE_TYPES,
										size: MAX_FILE_SIZE_MB
									})}
									onClick={() => openFileInNewTab(file.file)}
									onDelete={() => onDelete(file.id)}
								/>
							))}
						</div>
					)}
				</div>
			</div>

			<IconButton
				classes={{
					root: css.iconButton
				}}
				onClick={onClickHandler}
			>
				<CdnIcon icon={'Action/Attach file'} />
			</IconButton>
		</div>
	);
};

export default AttachFile;
